module.exports = __webpack_public_path__ + "static/media/tipo2.8ec7bb2f.png";